
Checkout.Payment.PriorAuth = function(checkout, payment) {
	var priorauth = this;

	this.label = 'Prior Authorization';

	this.$tpl = $('#payment-method-priorauth-tpl');

	this.$wrap =
	this.$authNum =
	this.$cardType =
		false;

	this.init = function() {

		priorauth.$wrap = priorauth.$tpl
			.clone(true)
			.removeAttr('id');

		priorauth.$authNum = priorauth.$wrap.find('.payment-method-priorauth-num');
		priorauth.$cardType = priorauth.$wrap.find('.payment-method-priorauth-cardtype');
    priorauth.$amtInput = priorauth.$wrap.find('.payment-method-amount input');
    priorauth.$loadingOverlay = priorauth.$wrap.find('.payment-loading-overlay');
    priorauth.$loadingMsg = priorauth.$loadingOverlay.find('.msg-text');
    priorauth.availableBalance = undefined;
		priorauth.priorAmount = undefined;
    priorauth.availableBalances = {};
    priorauth.authNumber = '';

    priorauth.$authNum.change( function() {
      var data = priorauth.getData();
      if ( data['authNum'] != priorauth.authNumber ) {
        priorauth.authNumber = priorauth.$authNum.val();
        priorauth.availableBalance = undefined;
      }
    });
    priorauth.$cardType.blur( function() {
      priorauth.$authNum.blur();
    });
    priorauth.$authNum.blur( function() {
      priorauth.getPaypalBalance();
    });


	};

  this.loading = function(loadingMsg) {
    if (loadingMsg) {
      priorauth.$loadingMsg.html(loadingMsg);
      priorauth.$loadingOverlay.show();
      checkout.alignMiddle(priorauth.$loadingOverlay.find('.msg'), priorauth.$loadingOverlay);
    } else
      priorauth.$loadingOverlay.hide();
  };

  this.afterChangeAmt = function(amount) {
    var data = priorauth.getData();
		if ( parseFloat( data['amtInput']) != 0 ) {
			priorauth.priorAmount = parseFloat( data['amtInput'] );
		}
    if (!data['authNum'] || data['cardType'] != 'paypal') {
      return;
    }
    priorauth.availableBalance = undefined;
    if (typeof priorauth.availableBalances[ data['authNum' ]] !== 'undefined') {
      priorauth.availableBalance = priorauth.availableBalances[ data['authNum'] ];
			priorauth.availableBalance = parseFloat( priorauth.availableBalance );
			amount = parseFloat( amount );
    }
    if (typeof priorauth.availableBalances == 'undefined') {
      priorauth.getPayPalBalance();
    } else if ( amount > priorauth.availableBalance ) {
      priorauth.$amtInput.val( parseFloat(priorauth.availableBalance).toMoney() );
    }
  };


  this.getPaypalBalance = function() {
    var data = priorauth.getData();

    if (priorauth.request)
      priorauth.request.abort();

    if (!data['authNum'] || data['cardType'] != 'paypal') {
      return;
    }

    priorauth.availableBalance = undefined;
    if (typeof priorauth.availableBalances[ data['authNum'] ] !== 'undefined') {
      priorauth.availableBalance = priorauth.availableBalances[ data['authNum'] ];
    }

    if (typeof priorauth.availableBalance !== 'undefined') {
				var numAmount = parseFloat( priorauth.$amtInput.val() );
				var numAvailableBalance = parseFloat( priorauth.availableBalance );
				if (numAmount == 0) {
					numAmount = parseFloat(priorauth.priorAmount);
				}
				if (numAmount != 0) {
					priorauth.priorAmount = numAmount;
				}
        if (numAmount > numAvailableBalance || numAmount == 0) {
          priorauth.$amtInput.val(parseFloat( priorauth.availableBalance ).toMoney() );
        } else {
          priorauth.$amtInput.val(parseFloat( numAmount ).toMoney() );
				}
        return;
    }

    // priorauth.$cardType.blur();
    priorauth.loading('Loading Prior Paypal Authorization');

    priorauth.request = checkout.remote.call({
      'data': {
        'step': 'payment',
        'action': 'checkPayPalPriorAuth',
        'payRef': data['authNum']
      }
    })
      .done(function(response) {

        priorauth.loading(false);
        priorauth.availableBalances[data['authNum']] = response.data.balance;
        priorauth.availableBalance = response.data.balance;
				var numAmount = parseFloat( priorauth.$amtInput.val() );
				var numAvailableBalance = parseFloat( priorauth.availableBalance );
        if (numAmount == 0) {
          numAmount = parseFloat(priorauth.priorAmount);
        }
				if (numAmount != 0) {
        	priorauth.priorAmount = numAmount;
				}
        if (numAmount > numAvailableBalance || numAmount == 0) {
          priorauth.$amtInput.val(parseFloat( priorauth.availableBalance ).toMoney() );
        } else {
          priorauth.$amtInput.val(parseFloat( numAmount ).toMoney() );
        }
      })
      .fail(function(request) {

        priorauth.loading(false);
        if (request.responseText)
          payment.fieldError(priorauth['$authNum'], request.responseText);
        else
          payment.fieldError(priorauth['$authNum'], 'Prior Authorization does not exist or has been completely captured.');

        priorauth.availableBalance = undefined;
        delete priorauth.availableBalances[ data['authNum'] ];

        priorauth.$amtInput.val('0.00');
        priorauth.$authNum.focus();
      }).
      always(function() {
         priorauth.loading(false);
         payment.reApplyBalances();
      });
  };

	this.getData = function() {
    var data = {
      'authNum': priorauth.$authNum.val(),
      'cardType': priorauth.$cardType.val(),
      'amtInput': priorauth.$amtInput.val()
		};
    for (var field in data) {
      if (data[field]) {
        data[field] = data[field].trim();
      }
    }
    return data;
	};


	this.validate = function() {
		var valid = true,
			data = priorauth.getData();

		// All Required
		for (var field in data) {
			if (!data[field]) {
				valid = false;
				payment.fieldError(priorauth['$'+field], 'Required');
			}
		}
    if (priorauth.$cardType.val() == 'paypal' && data['authNum']) {
        var availPaypal = parseFloat(priorauth.availableBalances[ data['authNum'] ]);
				var amtInput = parseFloat(data['amtInput']);
        if (availPaypal < amtInput) {
          payment.fieldError(priorauth['$authNum'], 'Value larger than authorized amount remaining');
          valid = false;
        }
    }

		return valid;
	};


	this.fieldErrors = function(errors) {
		for (var field in errors)
			payment.fieldError(priorauth['$'+field], errors[field]);
	};

	this.init();
};

